export default __webpack_public_path__ + "static/media/chevron-left.982a40d4.svg";